enum Routes {
  MAIN,
  CHANNELS_LINEUP,
  ZAPPER,
  DETAIL,
  PLAYER,
  CORNER,
}

export default Routes;
